<template>
	<div id="xl-jiangxi">
		<v-nav></v-nav>
		<v-banner></v-banner>
		<v-main></v-main>
		<v-footer></v-footer>
	</div>


</template>

<script type="text/javascript">

import Nav from './Nav.vue'

import Banner from './Banner.vue'

import Main from './Main.vue'

import Footer from './Footer.vue'

export default{
	name:"xl-jiangxi",
	data () {
		return {
			msg:"aassdsa"
		}
	},
	components:{
		"v-nav":Nav,
		"v-banner":Banner,
		"v-main":Main,
		"v-footer":Footer
	}
}

</script>


// WEBPACK FOOTER //
// Home.vue?4880100a